import template from './submit-timesheet.html';
import controller from './submit-timesheet.controller';

let SubmitTimesheetModal = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  size: 'lg',
  controllerAs: '$ctrl',
  windowClass: "hmodal-info animated zoomIn"
};

export default SubmitTimesheetModal;



// WEBPACK FOOTER //
// ./client/pages/timesheet/modals/submit-timesheet/submit-timesheet.component.js